import AbsComponent from '../../common/components/AbsComponent';
import Templ from './FriendTempl';

/**
 * Friend class
 * @category mainApp
 */
class Friend extends AbsComponent{
	constructor(_store = {}, _el = '') {
		super(_store, _el);

		if (this.store.getData('config').isLogin) {
			this.store.getData('Friend', {}, this.render.bind(this));
			$(this.el + ' .loading-wrap').show();
		}
	}

	render(_jsonData = {}) {
		this.data = _jsonData;

		if(_jsonData.exceptionClassName == 'RepresentativeCharacterNotFoundException') { // 대표 캐릭터가 존재하지 않는 경우
			$(this.el).append( Templ.NoBossChar() );
			return;
		}

		$(this.el + ' .loading-wrap').hide();
		const counter = Templ.getCounter(_jsonData);
		$(this.el).append(Templ.getTempl(_jsonData ,  this.store.data.config.profileDomain, this.store.data.config.sandboxDomain ));

		TweenMax.fromTo([this.el + ' .friend-list'], 0.5, {opacity: 0, y: 20}, {opacity: 1, y: 0});
		TweenMax.fromTo([this.el + ' .nodata'], 0.5, {opacity: 0}, {opacity: 1});

		if(counter > 0) $('.friend-count').append( counter ).removeClass('is-hide').addClass('is-show');

		this.setting();
		this.addEvents();
	}

	setting(){
	}

	addEvents(){
	}
}

export default Friend;